import {
  Device,
  DeviceAssignmentsTableFilterDataType,
  DeviceGroupsCriteria,
  WorkOrderDetailsDeviceData,
} from '@order-management/types';

type DeviceGroupFilterCriteria =
  | DeviceGroupsCriteria
  | DeviceAssignmentsTableFilterDataType;

export function filterDevices(
  devices: Device[] | WorkOrderDetailsDeviceData[],
  criteria: DeviceGroupFilterCriteria
) {
  return devices.filter((device) => filterDeviceByCriteria(device, criteria));
}

function filterDeviceByCriteria(
  device: Device | WorkOrderDetailsDeviceData,
  criteria: DeviceGroupFilterCriteria
) {
  if (
    criteria.deviceTypes?.length &&
    !criteria.deviceTypes.some((type) => type === device.model.displayName)
  )
    return false;

  if (criteria.softwareTitles?.length) {
    if (
      !device.assignments
        .filter((a) => a.softwareSeat)
        .some((a) =>
          criteria.softwareTitles?.includes(
            a.softwareSeat.licensingProductGroup.displayName
          )
        )
    )
      return false;
  }

  if (
    criteria.salesOrders?.length &&
    !criteria.salesOrders.some((number) => {
      const criteriaSearchNumberValue = number.replace(/\D/g, '');
      return (
        device.salesOrderLine.salesOrder.number ===
        Number(criteriaSearchNumberValue)
      );
    })
  )
    return false;
  return true;
}

export function getDevicesWithSameSoftwareTitles(devices: Device[]) {
  const groupedDevices = new Map<string, Device[]>();
  devices.forEach((device) => {
    const deviceSoftwareTitles = device.assignments
      .filter((assignment) => assignment.softwareSeat)
      .map(
        (assignment) =>
          assignment.softwareSeat.licensingProductGroup.displayName
      )
      .sort()
      .join('');
    const deviceConfiguration = `${device.model.id}${deviceSoftwareTitles}`;
    const devicesWithSameConfiguration =
      groupedDevices.get(deviceConfiguration);
    if (devicesWithSameConfiguration) {
      devicesWithSameConfiguration.push(device);
    } else {
      groupedDevices.set(deviceConfiguration, [device]);
    }
  });
  return Array.from(groupedDevices.values());
}
